<template>
	<div class="calendar">
		<div class="now-mouth">{{ displayDate }}
			<div class="checkALL" @click="checked">{{$t('btn_26')}}</div>
			<div class="checkUnALL" @click="unChecked">{{$t('btn_27')}}</div>
		</div>
		<div class="calendar_sd">
			<div class="calendar-title">
				<!--<div class="calendar-select">
          <div v-for="(week,index) in weekName " :key="index" class="calendar-select-row">
            <input
              :id="'calendarSet_calendar_week_input_'+genID()"
              :ref="'week_'+index"
              class="checkbox"
              type="checkbox"
              :name="week"
              @change="checked('week',index)"
            >
          </div>
          <div class="calendar-select-row"/>
        </div>-->
				<div class="calendar-select">
					<div v-for="(week, index) in weekName" :key="index" class="calendar-select-row">
						<div class="week"> {{ week }}</div>
					</div>
					<!--<div class="calendar-select-row">
            &lt;!&ndash;<input :id="'calendarSet_calendar_week_input_'+genID()" ref="checkAll" class="checkbox" type="checkbox"
                   @change="checkAll">&ndash;&gt;
          </div>-->
				</div>
			</div>
			<div class="calendar-body">
				<div v-for="(week, weeKIndex) in calendarDay" :key="weeKIndex">
					<div class="calendar-select">
						<div v-for="(day, dayIndex) in week" :key="dayIndex" class="calendar-select-row" :class="{isSelected: day.select}"
						 @click="selectDay(day)">
							<template v-if="day.isMonth=='1'">
								<div v-show="day.day" class="day LastMonth">
									{{ day.day }}
								</div>
							</template>
							<template v-if="day.isMonth=='0'">
								<div v-show="day.day" class="day" :class="(dayIndex=='0'||dayIndex=='6')?'isWeekend':''">
									{{ day.day }}
								</div>
							</template>
						</div>
						<!--<div class="calendar-select-row">
              <input
                v-show="week[0].day || week[6].day"
                :id="'calendarSet_calendar_week_input_'+genID()"
                :ref="'row_'+weeKIndex"
                class="checkbox"
                type="checkbox"
                @change="checked('row',weeKIndex)"
              >
            </div>-->
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'calendarPage',
		components: {},
		props: {
			mouth: {
				type: String,
				required: true
			},
			calendarOptiondDay: {
				type: Array,
				required: true
			},
			startDay: {
				type: String,
				required: true
			},
			endDay: {
				type: String,
				required: true
			},
		},
		data() {
			return {
				displayDate: '',
				nowDay: '',
				calendarDay: [],
				checkedDay: [],
				weekName: [this.$t('label_588'), this.$t('label_574'), this.$t('label_576'), this.$t('label_578'), this.$t('label_581'), this.$t('label_583'), this.$t('label_586')]
			}
		},
		computed: {},
		watch: {
			mouth(newMouth) {
				this.createCalendar(newMouth)
			},
			calendarOptiondDay(val) {
				if (val) {
					this.createCalendar(this.mouth)
				}
			},
			calendarDay: {
				handler(canlendar) {
					this.checkedDay = []
					let row = new Set()
					let column = new Set()
					canlendar.forEach(week => {
						week.forEach(day => {
							if (day && day.day) {
								if (day.select) this.checkedDay.push(day)
								else {
									row.add(day.week)
									column.add(day.row)
								}
							}
						})
					})
					let week = [0, 1, 2, 3, 4, 5, 6]
					/*week.forEach(r => {
					  let weekRef = 'week_' + r
					  let rowRef = 'row_' + r
					  console.log(this.$refs)
					  if (this.$refs[weekRef]){
					    if (row.has(r)) this.$refs[weekRef][0].checked = false
					    else this.$refs[weekRef][0].checked = true
					    if (this.$refs[rowRef])
					      if (column.has(r)) this.$refs[rowRef][0].checked = false
					      else this.$refs[rowRef][0].checked = true
					  }
					})*/
					// console.log(row,column)
					/* if (row && row.size > 0 && column && column.size > 0) {
					   this.$refs.checkAll.checked = false
					   this.$emit('checkedAll', {'mouth': this.mouth, 'checkedAll': false})
					 } else {
					   this.$refs.checkAll.checked = true
					   this.$emit('checkedAll', {'mouth': this.mouth, 'checkedAll': true})
					 }*/
					this.$emit('checkedDate', {
						'mouth': this.mouth,
						'checkedDay': this.checkedDay
					})
					// console.log(this.checkedDay)
				},
				deep: true
			}
		},
		created() {
			this.createCalendar(this.mouth)
		},
		methods: {
			selectDay(day) {
				if (day.date == undefined) {
					return;
				}
				if (day && day.day) this.$emit('selectDay', day)
			},
			checked() {
				this.calendarDay.forEach(week => {
					week.forEach(day => {
						if (day.isMonth == '0') {
							day.select = true
						}
					})
				})
			},
			unChecked() {
				this.calendarDay.forEach(week => {
					week.forEach(day => {
						if (day.isMonth == '0') {
							if (day.select) {
								day.select = false
							} else {
								day.select = true
							}
						}
					})
				})
			},
			checkWork(isOnWork, select) {
				this.calendarDay.forEach(week => {
					week.forEach(day => {
						if (day && day.day) {
							if (isOnWork && (day.week > 0 && day.week < 6)) {
								day.select = select
							} else if (!isOnWork && (day.week === 0 || day.week === 6)) {
								day.select = select
							}
						}
					})
				})
			},
			checkAll(val) {
				this.calendarDay.forEach(week => {
					week.forEach(day => {
						day.select = false;
						val.forEach(selctDay => {
							if (day.date == selctDay.restDay) day.select = true
						})
					})
				})
			},
			createCalendar(mouth) {
				if (mouth) this.nowDay = moment(mouth).format('YYYY-MM')
				else this.nowDay = moment().format('YYYY-MM')
				this.displayDate = moment(this.nowDay).format('MM')
				this.calendarDay = this.getCurrMonthDays(this.nowDay)
			},
			getCurrMonthDays(theDay) {
				// 获取当前月的第一天
				const start = moment(theDay).add('month', 0).format('YYYY-MM') + '-01'
				// 获取上一个月的总天数
				const lastMonthDays = moment(this.date).subtract(1, 'month').daysInMonth()
				// 构造日历的42个格子
				const daysArr = [
					[],
					[],
					[],
					[],
					[],
					[]
				]
				// 获取当前月的第一天是星期几
				const currentWeekday = moment(start).format('E')
				// 获取当前月的总天数
				const nowMouthDays = moment(theDay).daysInMonth()
				for (let i = 0; i < 7; i++) { // 每一周
					// 虚拟天数
					let virtualDay
					if (currentWeekday - 7 === 0) virtualDay = (lastMonthDays - currentWeekday) + i + 8
					else virtualDay = (lastMonthDays - currentWeekday) + i + 1
					for (let j = 0; j < daysArr.length; j++) { // 每一天
						daysArr[j][i] = this.getDay(i, j, start, virtualDay + (j * 7), lastMonthDays, nowMouthDays) // 每一行*7
					}
				}
				return daysArr
			},
			getDay(week, row, start, day, lastMonthDays, nowMouthDays, index) {
				let dayObj = {}
				if (day <= lastMonthDays) { // 上一月
					// return day
					dayObj = {
						'day': day,
						'isMonth': '1'
					}
				} else if (day <= (lastMonthDays + nowMouthDays)) {
					const dayNum = day - lastMonthDays
					const date = moment(start).add(dayNum - 1, 'days').format('YYYY-MM-DD')
					if (this.startDay <= date && this.endDay >= date) {
						dayObj = {
							day: dayNum,
							date: date,
							week: week,
							row: row,
							isMonth: '0',
							isToday: new Date(date).getTime() === new Date(moment().format('YYYY-MM-DD')).getTime(),
							select: !!this.calendarOptiondDay.find((day) => day.date === date)
						}
					} else {
						dayObj = {
							'day': dayNum,
							'isMonth': '1'
						}
					}
				} else { // 下一月
					//return day - (lastMonthDays + nowMouthDays)
					dayObj = {
						'day': day - (lastMonthDays + nowMouthDays),
						'isMonth': '1'
					}
				}
				return dayObj
			},
			genID() {
				return Number(Math.random().toString().substr(3, 4) + Date.now()).toString(36)
			}
		}
	}
</script>

<style scoped>
	.calendar {
		margin: 10px 5px;
		width: 23%;
		min-width: 230px;
		display: flex;
		flex-direction: column;
		margin-bottom: 15px;
		margin-right: 15px;
	}

	.calendar_sd {
		width: 100%;
		background: #f1f1f1;
	}

	.now-mouth {
		margin-bottom: 3px;
		line-height: 30px;
		font-size: 18px;
		font-weight: bold;
		background: #e5eef9;
		padding: 5px 10px;
		position: relative;
	}

	.calendar-week {
		min-width: 35px;
	}

	.calendar-select {
		display: flex;
		flex-direction: row;
	}

	.calendar-select-row {
		width: 15%;
		min-width: 30px;
	}

	.checkbox {
		margin-top: 6px;
		margin-left: 7px;
		background-color: #ddd;
	}

	.week {
		padding: 5px 0;
		text-align: center;
		font-size: 12px;
	}


	.day {
		padding: 5px 0;
		text-align: center;
		cursor: pointer;
		margin: 3px;
		font-size: 12px;
	}

	.LastMonth {
		color: #dedede;
	}

	.isWeekend {
		/* background: #0353c1;
    border-radius: 25px; */
		color: #ff9900;
	}

	.isSelected {
		background-color: #0353c1;
		border-radius: 25px;
		color: #ffffff;
	}

	.checkALL,
	.checkUnALL {
		font-weight: normal;
		font-size: 12px;
		background: #43c477;
		color: #ffffff;
		position: absolute;
		width: 50px;
		top: 5px;
		text-align: center;
		border-radius: 5px;
		cursor: pointer;
	}

	.checkALL {
		right: 70px;
	}

	.checkUnALL {
		right: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/calendarRest/calendarPage.vue